// extracted by mini-css-extract-plugin
export default {"message-card":"Messages_message-card__yXQJx","container":"Messages_container__-yLcs","header":"Messages_header__B1UKF","messages":"Messages_messages__Xmhb3"};